"use client"

import { createContext, useContext, useEffect, useMemo, useState, type ReactNode } from "react"

type CurrentOrganisationContextValue = {
  organisationId: string | null
  setOrganisationId: (organisationId: string | null) => void
}

const noop = () => {}

const CurrentOrganisationContext = createContext<CurrentOrganisationContextValue>({
  organisationId: null,
  setOrganisationId: noop,
})

export function CurrentOrganisationProvider({
  organisationId: initialOrganisationId,
  children,
}: {
  organisationId: string | null
  children: ReactNode
}) {
  const [organisationId, setOrganisationId] = useState<string | null>(initialOrganisationId)

  useEffect(() => {
    setOrganisationId(initialOrganisationId)
  }, [initialOrganisationId])

  const value = useMemo<CurrentOrganisationContextValue>(() => ({
    organisationId,
    setOrganisationId,
  }), [organisationId])

  return (
    <CurrentOrganisationContext.Provider value={value}>
      {children}
    </CurrentOrganisationContext.Provider>
  )
}

export function useCurrentOrganisation() {
  return useContext(CurrentOrganisationContext)
}

export function useCurrentOrganisationId() {
  return useCurrentOrganisation().organisationId
}

export function useSetCurrentOrganisationId() {
  return useCurrentOrganisation().setOrganisationId
}
